import { render, staticRenderFns } from "./ConversationHistorySvg.vue?vue&type=template&id=d48abe7e"
import script from "./ConversationHistorySvg.vue?vue&type=script&lang=js"
export * from "./ConversationHistorySvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports